__turbopack_context__.v({
  "content": "Details-module__jV5TrW__content",
  "root": "Details-module__jV5TrW__root",
  "summary": "Details-module__jV5TrW__summary",
});
